import { render } from "./courseInfoQb.vue?vue&type=template&id=e0105a10&scoped=true"
import script from "./courseInfoQb.vue?vue&type=script&lang=js"
export * from "./courseInfoQb.vue?vue&type=script&lang=js"

import "./courseInfoQb.vue?vue&type=style&index=0&id=e0105a10&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0105a10"]])

export default __exports__